export default __webpack_public_path__ + "static/media/pumpkin.2795414a.jpg";